/* eslint-disable no-use-before-define */
/* eslint-disable consistent-return */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-destructuring */
/* eslint-disable padding-line-between-statements */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
import React, { useEffect, useContext } from 'react';
import { withRouter} from 'react-router-dom';
import appConfig from 'app-config';
import _ from 'lodash';
import moment from 'moment';
import { useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';
import {MLPortalSettingsService, Submission} from 'gw-capability-quoteandbind';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { AvailabilityService } from 'gw-capability-policycommon';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { MLGeoCompleteService,MLMultiLobsDataHolderService, MLBundleService, 
    MLSearchDataHolderService, MLHVQBridgeService, MLStateRolloutService } from 'ml-services-common-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLProductCodeUtil, MLLocalDateUtil, CampaignDataService } from 'ml-portals-util-js';
import { MLPolicyTypeUtil } from 'ml-portals-util-react';
import { PeriodStartDateComponent } from 'ml-capability-quoteandbind-common-react';

import messages from './MLQuoteEntry.messages';
import MLLinks from '../../../../../quote-and-buy/src/config/ml-links.json';

const BUNDLED = 1;
const BOOKROLL_WITH_RATE_CAPPING = 'with_Rate_Capping';
const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';
const GW_POLICY_LOCKED_ML_EXCEPTION = 'PolicyLockedExceptionML';
const DISPLAYABLE_EXCEPTIONML= 'DisplayableExceptionML';
const DATABASE_BEAN_EXCEPTION = 'conflict';
const HVQ_QUOTEID_PREFIX = 'HVQ';
const QUOTE_RETRIEVAL_ERRORS = '808';
const PROD_ENV = 'prod';

function MLQuoteEntry(props) {
    const modalApi = useModal();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    let isCRBridgeQuoteForVUEError;

    let submissionVM;

    const { history } = props;
    const {
        showProgressDialog,
        showErrorModal
    } = MLModalService();
    const {
        getPolicyTypeName
    } = MLPolicyTypeUtil();

    const {
        runtimeEnv, errorCodes
    } = appConfig;

    const getWizardLink = (lobCode) => {
        const lobWizardLinks = {
            BusinessOwners: '/quote-bop',
            Homeowners: '/quote-ho',
            HOPHomeowners: '/quote-ho',
            PersonalAuto: '/quote-pa',
            PersonalUmbrella: '/quote-pup'
        };
        return lobWizardLinks[lobCode];
    };

    const _refreshPortalStorageAndResume = (submissionData, resumeCallback) => {
        const handleRetrieve = () => {
            if (!MLMultiLobsDataHolderService.hasNext()) {
                MLMultiLobsDataHolderService.addJobFromSubmission(submissionData, authHeader);
            }
            resumeCallback();
        };
        MLMultiLobsDataHolderService.reset();
        const refreshPortalStorage = MLMultiLobsDataHolderService.retrieveFromPortalStorage(submissionData.baseData.accountNumber, submissionData.quoteID, authHeader);
        refreshPortalStorage.then(handleRetrieve, handleRetrieve);
    };

    const proceedToWizardSteps = () => {
        const stateParams = _.get(history, 'location.state');
        const wizardLink = getWizardLink(submissionVM.baseData.productCode.value);        
        let submission = submissionVM.value;
        submission = JSON.parse(JSON.stringify(submission));
        
        history.push(wizardLink, { submission, resumeFlow: true, returnToQuote: stateParams?.returnToQuoteFlag, jumpToQuote: stateParams?.jdpQuote});

        localStorage.setItem('quoteID', submissionVM.quoteID.value);
        localStorage.setItem('firstName', submissionVM.value.getAccountHolderPerson().firstName);
    };

    const _resumeFlow = () => {
        _refreshPortalStorageAndResume(submissionVM.value, () => {
            if (submissionVM.value.bundleID_ML === BUNDLED) {
                const stateParams = _.get(history, 'location.state');
                MLTagManagerService.sendBundleFormStartEvent(stateParams.editBundle, {
                    product: submissionVM.baseData.productCode.value
                });
            }
            proceedToWizardSteps();
        });
    };

    const showModalError = (message, actionLabel, goNext) => {
        modalApi.showModal(
            <FormModalPopover
                title=''
                simpleMessage={message}
                actionBtnLabel={actionLabel}
                closeSimpleMessage
                showActionButton
                showHeader={false}
            />
        ).catch(_.noop);
    };

    const _getPolicyTypeText = (productCode) => {
        let policyTypeMessage = '';
        if (MLProductCodeUtil.isPersonalAuto(productCode)) {
            policyTypeMessage = translator(messages.mlAuto);
        } else if (MLProductCodeUtil.isHomeOwners(productCode)) {
            policyTypeMessage = translator(messages.mlHomeowners);
        } else if (MLProductCodeUtil.isPersonalUmbrella(productCode)) {
            policyTypeMessage = translator(messages.mlUmbrella);
        }
        return policyTypeMessage;
    };

    const _handleAvailabilityError = () => {
        const message = translator(messages.technicalDifficulties);
        const actionLabel = _.upperCase(translator(messages.closeWindow));
        showModalError(message, actionLabel, 'qnbHome');
    };

    const _handleUnavailableProduct = (availabilityResult) => {
        const policyTypeMessage = _getPolicyTypeText(availabilityResult.productCode_ML);
        const message = translator(messages.unableToProceed, { policyType: policyTypeMessage });
        const actionLabel = _.upperCase(translator(messages.closeWindow));
        showModalError(message, actionLabel, 'qnbHome');
    };

    const _redirectToFarmersPage = () => {
        window.location.href = MLLinks.myAutoHome;
    }

    const _extractMessageFromError = (errorMessage) => {
        const startPointRegex = "DisplayableExceptionML: ";
        const endPointRegex = " Messages_ML:";
        const startIndex = errorMessage.indexOf(startPointRegex);
        const endIndex = errorMessage.indexOf(endPointRegex);
        return errorMessage.substring(startIndex + startPointRegex.length, endIndex);
    }

    const _showQuoteDeclinedError = (errorMessage) => {
        modalApi.showAlert({
            title: '',
            message: _extractMessageFromError(errorMessage),
            confirmButtonText: messages.mlModalCloseButton,
            status: 'error',
        }).then(() => {
            _redirectToFarmersPage();
        }, _.noop);
    }

    const isHvqQuoteId = (quoteID) => {
        return quoteID && quoteID.toUpperCase().startsWith(HVQ_QUOTEID_PREFIX);
    };

    const handleBridgingError = (stateParams) => {
        stateParams.showError = true;
        stateParams.isHVQError = true;
        if (stateParams.pageState === 'startQuote') {
            stateParams.showMaxError = true;
        } else {
            stateParams.showMaxError = false;
        }
        history.push('/', stateParams)
    };

    const vueErrorCodes = ['V214', 'V240'];

    useEffect(() => {
        // Reset the Page Load Time when user is going through the quote entry flow
        sessionStorage.setItem('userSubmitAction', true);
        sessionStorage.setItem('userSubmitted', new Date());
        const gpaMode = appConfig.portalCode === 'GPA';
        const qnbMode = appConfig.portalCode === 'QB';

        let stateParams = _.get(history, 'location.state');

        if (!stateParams && location.search) {
            // Retrieve quote from external entry point
            const queryParams = new URLSearchParams(location.search);
            const quoteIdfromUrl = queryParams.get('q');
            const zipCodeFromUrl = queryParams.get('z');

            // JDP - Jump directly to quote page for JDP deep link
            const jdpQuote = queryParams.get('jdpQuote');

            if (zipCodeFromUrl && quoteIdfromUrl) {
                stateParams =             {
                    quoteID: quoteIdfromUrl,
                    retrieveType_ML: 'quoteID',
                    postalCode: zipCodeFromUrl,
                    isHvq_ML: false,
                    pageState: 'retrieveQuote',                    
                    jdpQuote: jdpQuote === 'true' 
                }

                _.set(history, 'location.state', stateParams);
            }
        }

        const returnToQuoteFlag = stateParams?.returnToQuoteFlag || undefined;
        MLPortalSettingsService.getSettings(authHeader, true);

        const _isHvqQuoteML = (submissionData) => {
            return stateParams.isHvq_ML || submissionData.hvqQuoteID_ML;
        };

        const checkAvailability = (submissionModel, availabilityParams) => {
            const availabilityPromise = AvailabilityService.productAvailableBasedOnPostalCode(availabilityParams, authHeader);
            availabilityPromise.then(
                (availabilityResp) => {
                    if (availabilityResp.isAvailable) {
                        const isFromIAPortal = sessionStorage.getItem('fromIAPortal');
                        const userSubmitted = sessionStorage.getItem('userSubmitted');
                        const userSubmitAction = sessionStorage.getItem('userSubmitAction');
                        sessionStorage.clear();
                        if (isFromIAPortal === 'true') {
                            sessionStorage.setItem('fromIAPortal', true);
                        }
                        if (userSubmitAction === 'true') {
                            sessionStorage.setItem('userSubmitted', userSubmitted);
                            sessionStorage.setItem('userSubmitAction', userSubmitAction);
                        }
                        sessionStorage.setItem("quoteType" ,'New Business');
                        sessionStorage.setItem('QuoteStarted', true);
                    }
                    if (!availabilityResp.isAvailable) {
                        _handleUnavailableProduct(availabilityResp);
                    } else {
                        if (_.isUndefined(submissionModel.baseData.policyAddress.value)) {
                            submissionModel.baseData.policyAddress.value = availabilityResp.addressCompletion;
                        }
                        history.push(getWizardLink(submissionModel.baseData.productCode.value), { submission: submissionModel.value });
                    }
                },
                () => {
                    _handleAvailabilityError();
                }
            );
        }        

        const _handleErrorGeoComplete = (errorMessage) => {
            const actionLabel = _.upperCase(translator(messages.closeWindow));
            showModalError(errorMessage, actionLabel, 'qnbHome');
        };        

        const _createAvailabilityParams = (submission) => {
            return {
                effectiveDate: submission.baseData.periodStartDate,
                postalCode: stateParams.postalCode,
                productCode: submission.baseData.productCode,
                coveragePartType_ML: stateParams.coverageType,
                stateCode_ML: stateParams.stateCode_ML
            };
        };
        
        const _checkGeoComplete = (subVM, callback) => {
            const availabilityParams = _createAvailabilityParams(subVM.value);
            if (availabilityParams.stateCode_ML) {
                return callback(subVM, availabilityParams);
            }
            return MLGeoCompleteService.getState(availabilityParams.postalCode)
                .then((data) => {
                    availabilityParams.stateCode_ML = data.StateProvince;
                    return callback(subVM, availabilityParams);
                })
                .catch((errorMessage) => {
                    _handleErrorGeoComplete(_.isObject(errorMessage) ? errorMessage.message : errorMessage);
                });
        };

        const _checkProductAvailabilityAndStart = (submissionModel) => {
            _checkGeoComplete(submissionModel, (subVM, availabilityParams) => {
                checkAvailability(subVM, availabilityParams);
            });
        };        

        const _setCampaignData = (submission) => {
            const campaignData = CampaignDataService();
            if (campaignData) {
                if (campaignData.utm_campaign) {
                    const utmArray = campaignData.utm_campaign.split('_');
                    submission.baseData.trackingCode = [];
                    utmArray.forEach((utm) => {
                        submission.baseData.trackingCode.push({codeValue: utm, codeName: 'utm_campaign'});
                    });
                }
                submission.baseData.marketingInfo_ML = {
                    gPC: campaignData.gpc,
                    campaignId: campaignData.utm_campaign,
                    uniqueCampaignId: campaignData.utm_id,
                    channel: campaignData.utm_medium,
                    source: campaignData.utm_source,
                    content: campaignData.utm_content,
                    term: campaignData.utm_term,
                    onsiteMarketingId: campaignData.oc_id,
                    externalMarketingId: campaignData.mc_id,
                    promoId: campaignData.promoid,
                    everQuoteToken: campaignData.cid
                };
            }
        };
        
        const _createNewSubmissionForProduct = (productCode, productType) => {
            const submission = new Submission();
            submission.baseData.productCode = productCode;
            submission.baseData.periodStartDate = stateParams.effectiveDate;

            if (stateParams.account) {
                submission.baseData.accountHolder = stateParams.account.accountHolder;
                submission.baseData.accountNumber = stateParams.account.accountNumber;
                submission.baseData.policyAddress = {};
                Object.assign(submission.baseData.policyAddress, stateParams.account.accountHolder.primaryAddress);
            }

            _setCampaignData(submission);

            submission.lobData = submission.lobData || {}; 
            if (stateParams.coverageType) {
                submission.lobData.homeowners = submission.lobData.homeowners || {};
                submission.lobData.homeowners.coverables = submission.lobData.homeowners.coverables || {};
                submission.lobData.homeowners.coverables.coveragePartType_ML = stateParams.coverageType || productType;
            }

            if (stateParams.offeringCode_ML) {
                submission.baseData.offeringCode_ML = stateParams.offeringCode_ML;
            }

            if (stateParams.producerCode) {
                submission.baseData.producerCode_ML = stateParams.producerCode;
            }

            submission.baseData.producerAutoUpdated_Ext = stateParams.isProducerCodeChangedAutomatically || false;

            submission.hasExistingSubmissions_ML = stateParams.hasExistingSubmissions_ML;

            return viewModelService.create(submission, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO');
        };

        const _createNewBundleSubmissionForProduct = (productCodeType) => {
            const newSub = _createNewSubmissionForProduct(productCodeType.productCode, productCodeType.productType);
            newSub.isBundle_ML = true;
            return newSub;
        };        
        
        const _checkProductAvailabilitiesAndStart = (submissionVMs) => {
            const availabilitiesPromises = submissionVMs.map((subVM) => {
                return _checkGeoComplete(subVM, (subModel, availabilityParams) => {
                    return AvailabilityService.productAvailableBasedOnPostalCode(availabilityParams, authHeader);
                });
            });

            Promise.all(availabilitiesPromises)
                .then((availabilityResults) => {
                    const hasUnavailableProduct = availabilityResults.some((result) => !result.isAvailable);
                    if (hasUnavailableProduct) {
                        const unavailableProduct = availabilityResults.find((result) => !result.isAvailable);
                        _handleUnavailableProduct(unavailableProduct);
                    } else {
                        availabilityResults.forEach((result, index) => {
                            if (_.isUndefined(submissionVMs[index].baseData.policyAddress.value)) {
                                submissionVMs[index].baseData.policyAddress.value = result.addressCompletion;
                            }
                        });
                        MLBundleService.addJobsToCreate(stateParams.productCodes);
                        const productsBundle = stateParams.productCodes.map((sub) => MLTagManagerService.getPolicyTypeName(sub.productCode)).join('|');
                        MLTagManagerService.sendBundleFormStartEvent(stateParams.editBundle,
                            {product: submissionVMs[0].baseData.productCode.value, bundleChoose: productsBundle});

                        history.push(getWizardLink(submissionVMs[0].baseData.productCode.value), { submission: submissionVMs[0].value });
                    }
                })
                .catch(() => {
                    _handleAvailabilityError();
                });
        };

        const _bridgeHvqQuote = () => {
            const bridgingPromise = MLHVQBridgeService.createFromHVQQuoteIdAndPostalCodeOnNewAccount(stateParams.quoteID, stateParams.postalCode);
            showProgressDialog(platformMessages.loading, bridgingPromise, true);
            bridgingPromise.then((hvqRes) => {
                if (!_.isUndefined(hvqRes) && hvqRes.jobID) {
                    stateParams.quoteID = hvqRes.jobID;
                    stateParams.postalCode = hvqRes.policyAddress.postalCode;
                    _checkRoutesByQuoteId(stateParams.quoteID);
                } else {
                    handleBridgingError(stateParams);
                }
            }, (error) => {
                console.error(error);
                handleBridgingError(stateParams);
            });
        }

        const _getWizardEntryIMFStep = (quotes, quoteNumber) => {
            const matchingQuote = quotes?.find((quote) => quote.jobNumber === quoteNumber);
            if (matchingQuote){
                if (matchingQuote.product.productCode === 'PersonalAuto'){
                    return 'compPaWizardEntry';
                }
                if (matchingQuote.product.productCode === 'HOPHomeowners'){
                    return 'compHoWizardEntry';
                }
            }
            return undefined
        };

        const _checkRoutesByQuoteId = (quoteId) => {
            // Check is a bridged quote or part of a bundle that has a CR bridged quote
            return MLBundleService.checkIsCRBridgedQuote(quoteId, authHeader)
                .then((isCRBridgeQuote) => {
                    isCRBridgeQuoteForVUEError = isCRBridgeQuote
                    // If yes, BE will return an array of the submission(1 or many). If not, BE will return false
                    if(isCRBridgeQuote && isCRBridgeQuote.length > 0 && !returnToQuoteFlag) {
                        // Check is fulfilled state rollout
                        return MLStateRolloutService.checkIsCRWizardEligible(quoteId, authHeader)
                            .then((isCREligible) => {
                                if(isCREligible) {
                                    // Check is not coming from Bridged Quote Summary
                                    const isEditQuoteFromCRWizard = stateParams.agentCompRaterStartEditingQuote || undefined;
                                    if(!isEditQuoteFromCRWizard) {
                                        // Check if all submissions in the array have been manually quoted
                                        if (isCRBridgeQuote && isCRBridgeQuote.every((sub) => sub.totalPremium.amount !== 0)) {
                                            // Check if it's monoline submission, therefore we don't want to land in Bundle Cart page, but process the submission
                                            if (isCRBridgeQuote.length === 1) {
                                                processSubmission();
                                            // Submission is a bundle, therefore we redirect user to the Bundle Cart page, unless the user has clicked on the Edit Quote button
                                            } else {
                                                const agentBundleCartInfo = {
                                                    accountNumber: stateParams.account
                                                };
                                                // Check if user has clicked on the Edit Quote button, therefore submission must be processed
                                                if(stateParams?.editSubmissionFromBundle || stateParams?.isPurchasing) {
                                                    processSubmission();
                                                }
                                                // User is accessing the bundle (not clicked Edit Quote button)
                                                else {
                                                    history.push(`/agent-bundle-cart/${stateParams.account}`, agentBundleCartInfo);
                                                }
                                            }
                                        }
                                        else if(qnbMode){
                                            processSubmission();
                                        }
                                        // At least 1 submission in the array has not been manually quoted, therefore user is redirected to comp-wizard
                                        else {
                                            history.push(`/comp-wizard/${stateParams.quoteID}`, {
                                                submissionNumber: stateParams.quoteID,
                                                bridgedQuotes: isCRBridgeQuote
                                            });
                                        }
                                    } else {
                                        // Trigger the IMF step to run integrations on submission retrieval
                                        const imfStep = _getWizardEntryIMFStep(isCRBridgeQuote, stateParams.quoteID);
                                        if (imfStep) {
                                            stateParams.IMFStep_ML = imfStep
                                        }
                                        processSubmission();
                                    }
                                } else {
                                    // Not fulfilled state rollout
                                    processSubmission();
                                }
                            })
                    } else {
                        // Not CR bridged quote
                        processSubmission();
                    }
                });
        }

        const processSubmission = () => {
            const submissionLoadPromise = LoadSaveService.retrieveSubmission(stateParams, authHeader);
            let progressMessage = translator(messages.retrievingDraftSubmission);
            if (stateParams.isBundle_ML && !stateParams.agentCompRaterStartEditingQuote) {
                if(qnbMode && !sessionStorage.getItem('IsBundle')){
                    sessionStorage.setItem('IsBundle', 'true');
                }
                progressMessage = MLBundleService.getProgressMessage(stateParams.quoteID, getPolicyTypeName);
            }
            showProgressDialog(progressMessage, submissionLoadPromise);

            submissionLoadPromise.then((submissionData) => {
                const _showEffectiveDatePopup = () => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    const tomorrow = new Date(today);
                    tomorrow.setDate(today.getDate() + 1);
                    const baseData = submissionVM.baseData;
                    baseData.gpaMode = gpaMode;
                    const submissionDate = submissionVM.baseData.periodStartDate.value;
                    if (!submissionVM.isSubmitAgent.value) {
                        baseData.dateInPast = new Date(submissionDate.year, submissionDate.month, submissionDate.day, 0, 1) < tomorrow;
                        if (baseData.dateInPast) {
                            submissionVM.baseData.periodStartDate.value = tomorrow;
                        }
                    }
                    const overrides = {
                        submissionVM
                    };
                    const componentProps = {
                        title: submissionVM.isSubmitAgent.value ? messages.mlGPAPeriodStartDatePopupTitle : messages.mlPeriodStartDatePopupTitle,
                        actionBtnLabel: _.upperCase(translator(platformMessages.mlContinue)),
                        cancelBtnLabel: _.upperCase(translator(platformMessages.mlCancel)),
                        overrideProps: overrides,
                        onSaveAction: () => {
                            _resumeFlow();
                            return true;
                        },
                        CustomComponent: PeriodStartDateComponent
                    };
                    modalApi.showModal(
                        <FormModalPopover {...componentProps} />
                    );
                };

                if (!submissionData.quoteID) {
                    stateParams.showError = true;
                    if (gpaMode) {
                        // $state.go('viewSubmissionSearch', $stateParams);
                    } else {
                        // $state.go('retrieveQuote', $stateParams);
                    }
                    return;
                }

                localStorage.setItem('quoteID', submissionData.quoteID);
                localStorage.setItem('firstName', submissionData.getAccountHolderPerson().firstName);

                const submissionPeriodStartDate = submissionData.baseData.periodStartDate;

                const startToday = new Date();
                startToday.setHours(0, 0, 0, 0);
                const startTomorrow = new Date(startToday.setDate(startToday.getDate() + 1));

                if (!gpaMode && moment(submissionPeriodStartDate).isBefore(moment(), 'day')) {
                    submissionData.baseData.periodStartDate = MLLocalDateUtil.date2LocalDate(startTomorrow);
                }

                // this will allow the primary insured selection
                submissionData.hasExistingSubmissions_ML = stateParams.hasExistingSubmissions_ML;

                submissionVM = viewModelService.create(submissionData, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO');
                const isBookrollQuote = submissionVM.bookrollInd_ML.value ? (submissionVM.bookrollInd_ML.value.code === BOOKROLL_WITH_RATE_CAPPING) : false;
                const isAlaska7Day = MLProductCodeUtil.isPersonalAuto(submissionData.baseData.productCode) && submissionData.baseData.policyAddress.state === 'AK' && submissionData.baseData.termType === '7Days';

                // TODO US800858 Add State Rollout logic to filter the states that not going to the new CompRater wizard
                if (!submissionData.isBundle_ML && submissionData.bindData && (submissionData.baseData.status_ML === 'Bound' || submissionData.baseData.status_ML === 'Binding')) {
                    // Monoline and the submission is quoted
                    // if the submission has a policy number,
                    // it should jump to the confirmation page.
                    _refreshPortalStorageAndResume(submissionVM.value, proceedToWizardSteps);
                } else if (_isHvqQuoteML(submissionData)) {
                    // CompRater Bridged Monoline submission
                    if (_.isUndefined(submissionVM.baseData.sameMailingAddress_ML.value)) {
                        submissionVM.baseData.sameMailingAddress_ML.value = true;
                    }
                    
                    if (qnbMode && _.isUndefined(submissionVM?.baseData?.bypassCreditOrdering_Ext?.value)){
                        submissionVM.baseData.bypassCreditOrdering_Ext.value = true
                    }
  
                    // ProducerEngage as Submission is created when bridge, so first time and Re-access will use the same entry
                    _refreshPortalStorageAndResume(submissionVM.value, proceedToWizardSteps);
                } else if (submissionData.isBundle_ML && stateParams.retrieveType_ML && submissionData.baseData.status_ML !== 'Bound' && submissionData.baseData.status_ML !== 'Binding') {
                    // What is retrieveType_ML indicating? If is Bundle and this submission status is draft
                    if(gpaMode){
                        // ProducerEngage
                        const agentBundleCartInfo = {
                            accountNumber: submissionData.baseData.accountNumber
                        };
                        history.push(`/agent-bundle-cart/${agentBundleCartInfo.accountNumber}`, agentBundleCartInfo);
                    }else{
                        // QNB
                        _refreshPortalStorageAndResume(submissionData, () => {
                            history.push('/bundle-cart', {
                                accountNumber: submissionData.baseData.accountNumber,
                                retrieval: true,
                                quoteID: stateParams.quoteID,
                                sessionUUID: submissionData.sessionUUID
                            })
                        });
                    }
                } else if (submissionData.isBundle_ML && stateParams.retrieveType_ML && (submissionData.baseData.status_ML === 'Bound' || submissionData.baseData.status_ML === 'Binding')) {
                    // What is retrieveType_ML indicating? If is Bundle and this submission status is quoted
                    _refreshPortalStorageAndResume(submissionData, () => {
                        history.push('/bundleConfirmation', {
                            accountNumber: submissionData.baseData.accountNumber, 
                        });
                    });
                } else if (submissionData.isBundle_ML) {
                    // QNB
                    if (!gpaMode || (submissionData.baseData.status_ML === 'Draft' && moment(submissionPeriodStartDate).isBefore(moment(), 'day') && !returnToQuoteFlag)) {
                        _showEffectiveDatePopup();
                    } else {
                        // ProducerEngage
                        _refreshPortalStorageAndResume(submissionVM.value, () => {
                            MLTagManagerService.sendBundleFormStartEvent(stateParams.editBundle,
                                {product: submissionVM.baseData.productCode.value});
                            proceedToWizardSteps();
                        });
                    }
                } else if (isBookrollQuote || isAlaska7Day) {
                    // Is Alaska State
                    if (gpaMode) {
                        if (submissionVM.value.isQuoted()) {
                            submissionVM.quoteData.offeredQuotes.value.forEach((quote) => {
                                quote.retrievedOnly = true;
                            });
                            _resumeFlow();
                        } else {
                            stateParams.showError = true;
                            // $state.go('viewSubmissionSearch', stateParams);
                        }
                    } else {
                        _resumeFlow();
                    }
                } else if (submissionVM.isSubmitAgent.value) {
                    // TODO check what is this condition for?
                    if (submissionVM.value.isQuoted() && !stateParams.jdpQuote) {
                        submissionVM.quoteData.offeredQuotes.value.forEach((quote) => {
                            quote.retrievedOnly = true;
                        });
                    }
                    if (moment(submissionPeriodStartDate).isBefore(moment(), 'day') && !returnToQuoteFlag) {
                        _showEffectiveDatePopup();
                    } else {
                        _resumeFlow();
                    }
                } else {
                    _showEffectiveDatePopup();
                }

            }).catch((error) => {
                const errorMessageStringArray = error.baseError?.split(' ');
                const errorMessageIndex = errorMessageStringArray?.lastIndexOf('ErrorMessage:');
                const errorMessageValue = errorMessageIndex !== -1 ? errorMessageStringArray[errorMessageIndex + 1] : undefined;
                
                const innerErrorCodeIndex = errorMessageStringArray?.lastIndexOf('ErrorCode:');
                const innerErrorCodeValue = innerErrorCodeIndex !== -1 ? errorMessageStringArray[innerErrorCodeIndex + 1] : undefined;
                const innerErrorCodeNumericValue = !_.isUndefined(innerErrorCodeValue) ? parseInt(innerErrorCodeValue, 10) : undefined;

                const goToContactUs = () => {
                    if(gpaMode){
                        history.push('/contactUs', error);
                        return;
                    }
                    const contactUsPath = 'quote-and-buy/contact-us';
                    const url = `${window.location.origin}/${contactUsPath}`;
                    window.location.href = url;
                };

                if (innerErrorCodeNumericValue && innerErrorCodeNumericValue === errorCodes.DISPLAYABLE_ERROR_ML) {
                    if (errorMessageValue.includes(GW_POLICY_LOCKED_ML_EXCEPTION)) {
                        MLBundleService.showErrorMessage(error, showErrorModal);
                        history.push('/');
                        return;
                    }
                    if (errorMessageValue.includes(DATABASE_BEAN_EXCEPTION)) {
                         showErrorModal(
                            messages.error,
                            messages.mlDatabaseBeanVersionConflictMessage,
                            messages.closeWindow
                        ).catch(_.noop);
                        return;
                    }
                    if (errorMessageValue.includes(DISPLAYABLE_EXCEPTIONML)) {
                        stateParams.technicalError = false;
                    } else {
                        goToContactUs(error, submissionVM);
                        return;
                    }
                } else {
                    stateParams.technicalError = true;
                }

                stateParams.showError = true;
                if (gpaMode) {
                    if (vueErrorCodes.some(code => error.baseError.includes(code))) {
                        MLBundleService.showErrorMessage(error, showErrorModal);
                        history.push(`/comp-wizard/${stateParams.quoteID}`, {
                            submissionNumber: stateParams?.quoteID,
                            bridgedQuotes: isCRBridgeQuoteForVUEError
                        });
                    }else{
                        MLSearchDataHolderService.setSearchBtnClicked(true)
                        const forceReloadUniqueId = Date.now() + Math.random();
                        history.push(`/search/undefined/${forceReloadUniqueId}`, {
                            quoteID: stateParams.quoteID
                        });
                    }
                } else {
                    // Indicating it is from quote entry instead of Landing Page
                    _.set(history, 'location.state.toggleRetrieveQuote', false);
                    if (stateParams.pageState === 'startQuote') {
                        stateParams.showMaxError = true;
                    } else {
                        stateParams.showMaxError = false;
                    }
                    if (runtimeEnv === PROD_ENV && stateParams?.isLoadedFromCampignUrl_Ext) {
                        if(error.errorCode === QUOTE_RETRIEVAL_ERRORS) {
                            _showQuoteDeclinedError(error.baseError);
                        } else {
                            _redirectToFarmersPage();
                        }
                    } else {
                        history.push('/', stateParams);
                    }
                }
            });
        }

        if (!stateParams && gpaMode) {
            history.push('/');
        } else if (stateParams.quoteID || stateParams.email_ML) { // resume draft submission
            if (isHvqQuoteId(stateParams.quoteID)) {
                _bridgeHvqQuote();         
            } else {
                _checkRoutesByQuoteId(stateParams.quoteID);
            }
        } else if (stateParams.productCodes && stateParams.productCodes.length > 1) { // bundle
            const submissions = [];
            stateParams.productCodes.forEach((product) => {
                const newSubVm = _createNewBundleSubmissionForProduct(product);
                submissions.push(newSubVm);
            });
            _checkProductAvailabilitiesAndStart(submissions);
            if(qnbMode && !sessionStorage.getItem('IsBundle')){
                sessionStorage.setItem('IsBundle',true);
            }
        } else { // monoline
            const submissionProductCode = (stateParams.productCodes && stateParams.productCodes.length === 1) ? stateParams.productCodes[0].productCode : stateParams.productCode;
            const submissionModel = _createNewSubmissionForProduct(submissionProductCode);
            if (!MLMultiLobsDataHolderService.hasNext()) {
                MLMultiLobsDataHolderService.addJobFromSubmission(submissionModel.value, authHeader);
            }
            _checkProductAvailabilityAndStart(submissionModel);
        }       
    }, []);

    return true;
}

export default withRouter(MLQuoteEntry);
